!-- 对话列表 -->
<template>
  <div id="dailyOperation" class="dailyOperation tabs-ctn">
    <div class="tabs-btn-ctn">
      <div class="tab-btn-item" @click="tabToggle(0)" :class="{'tab-active':tabInd == 0}">常用语</div>
      <div class="tab-btn-item" @click="tabToggle(1)" :class="{'tab-active':tabInd == 1}">访客记录</div>
      <div class="tab-btn-item" @click="tabToggle(2)" :class="{'tab-active':tabInd == 2}">常用操作</div>
    </div>
    <div class="tabs-content">
      <!--常用语-->
      <div class="tab-section daily-words" v-show="tabInd == 0 ">
        <el-input
          placeholder="搜索公用常用语(回车搜索)"
          v-model.trim="dailyWordsKey"
          @keyup.enter.native="dailyWordsSearch()"
        ></el-input>
        <!-- 搜索结果列表 -->
        <div class="words-search-result" v-show="showSearchResult">
          <i>搜索结果</i>
          <img
            src="../../assets/images/wd-back.png"
            @click="backTree"
            class="backTree-btn"
            title="返回我的常用语"
          >
          <el-tree
            :data="wordSearchResult"
            node-key="id"
            v-show="showSearchResult"
            :props="defaultProps"
            :filter-node-method="filterNode"
            :render-content="renderCommon"
            :default-expand-all="false"
            :expand-on-click-node="false"
          ></el-tree>
        </div>
        <!-- 两颗树 -->
        <div class="tree-ctn" v-show="!showSearchResult">
          <div class="daily-title" @click="hideEle(0)">
            <i class="el-icon-caret-bottom"></i>
            我的常用语
            <!-- 增加顶级常用语 -->
            <el-button
              type="text"
              size="mini"
              @click.stop="showDialog(0, '')"
              style="float:right;margin-right: 10px;"
            >新增</el-button>
          </div>
          <el-tree
            :data="myWords"
            node-key="id"
            v-show="mytreeShow"
            :props="defaultProps"
            :filter-node-method="filterNode"
            :render-content="renderContent"
            :default-expand-all="false"
            :expand-on-click-node="false"
          ></el-tree>
          <div class="daily-title" @click="hideEle(1)">
            <i class="el-icon-caret-bottom"></i>
            公用常用语
          </div>
          <el-tree
            v-show="commonTreeShow"
            class="filter-tree"
            :data="commonWords"
            :props="defaultProps"
            :default-expand-all="false"
            :render-content="renderCommon"
            :filter-node-method="filterNode"
            ref="tree2"
          ></el-tree>
        </div>
      </div>
      <!--访客记录-->
      <div class="tab-section access-log" v-show="tabInd == 1 ">
        <div v-show="nowKhMsg.uId">
          <div class="last-msg">上次接入客服时间:{{LastJoinTime}}</div>
          <div class="last-msg">上次接待人：{{LastReception}}</div>
          <div class="tree-ctn access-log-tree">
            <div class="daily-title" @click="hideEle(2)">
              <i class="el-icon-caret-bottom"></i>
              历史成交订单
            </div>
            <div v-show="historyCjShow">
              <el-card class="box-card order-item-ctn" v-for="(item,key) in DealOrders" :key="key">
                <div slot="header" class="clearfix">订单号：{{key}}</div>
                <!-- FBI WARNING start 不要改这里的dom结构！！！ -->
                <div class="order-item-content" style="height: 76px">
                  <div class="text item order-item history-item" v-for="(i,k) in item">
                    <img src="../../assets/images/tsl.jpg" alt="" class="order-cover">
                    <div>
                      <div class="order-name">{{i.GoodName}}</div>
                      <div
                        class="order-msg"
                      >成交时间：{{i.DealTime}} &nbsp;&nbsp;&nbsp;&nbsp;成交量：{{i.Count}}</div>
                    </div>
                  </div>
                </div>
                <div class="show-more" v-if="item.length>1">
                  <span @click="showMore($event)">显示更多</span>
                  <span @click="hideMore($event)" style="display: none">收起</span>
                </div>
                <!-- FBI WARNING end -->
              </el-card>
            </div>
            <div class="daily-title" @click="hideEle(3)">
              <i class="el-icon-caret-bottom"></i>
              历史询价订单
            </div>
            <div v-show="historyXjShow" class="history-ask">
              <div class="div-table-row history-title">
                <div class="div-table-cell" style="width: 33.3%">询价单号</div>
                <div class="div-table-cell" style="width: 33.3%">汽配名称</div>
                <div class="div-table-cell" style="width: 33.3%">汽配编码</div>
              </div>
              <div class="div-table-row" v-for="(item,key) in InquiryBills" :key="key">
                <div class="div-table-cell history-order-num" style="width: 33.3%">{{key}}</div>
                <div class="div-table-cell" style="width: 33.3%">
                  <div class="" v-for="(i,k) in item">
                    <div class="order-name">{{i.Cn}}</div>
                  </div>
                </div>
                <div class="div-table-cell" style="width: 33.3%">
                  <div class="" v-for="(i,k) in item">
                    <div class="order-name">{{i.Code}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="!nowKhMsg.uId" class="quesheng">请先选择顾客</div>
      </div>
      <!--常用操作-->
      <div class="tab-section daily-opts" v-show="tabInd == 2 ">
        <div class="daily-opts-btn-ctn">
          <el-button size="small" round @click="showDialog(2)" v-show="nowKhMsg.uType == 1">快速创建询价单</el-button>
          <el-button size="small" round @click="gotoHelpDoc">常见问题处理文档</el-button>
          <el-button size="small" round @click="showDialog(3)">创建企业客户</el-button>
          <el-button size="small" round @click="controlApDialogVisible(true)">添加汽配件</el-button>
        </div>
        <el-input
          size="small"
          placeholder="汽配快搜（编码或名称）回车搜索"
          v-model.trim="qpSearchText"
          @keyup.enter.native="searchQP"
        ></el-input>
        <div class="qp-choosed-label-ctn">
          <el-scrollbar style="height: 100%">
            <div class="qp-choosed-label-ctn">
              <el-tag
                class="qp-choosed-ctn"
                v-for="(item,index) in qpChoosedList"
                :key="item.Id"
                size="small"
                :title="item.Cn"
                @close="delqp(index)"
                closable
              >
                <span class="qp-choosed">{{item.Cn}}</span>
              </el-tag>
            </div>
          </el-scrollbar>
        </div>
        <div class="tree-ctn daily-opts-tree" v-show="!showPJResult">
          <el-scrollbar style="height:100%;">
            <el-card class="box-card order-item-ctn" v-for="(item,index) in qpList" :key="item.Id">
              <div class="text item order-item" @click="choosePJ(item)">
                <img :src="QN_URL_BASE+item.PublicUrl" alt="" class="order-cover">
                <div class="goods-msg-125">
                  <div class="order-name">{{item.Cn}}</div>
                  <div class="order-msg">编码：{{item.Code}} &nbsp;&nbsp;&nbsp;&nbsp;库存：10</div>
                  <div style="text-align: right;padding-top: 10px">
                    <el-button type="primary" size="mini" plain @click.stop="pushGoods(item)">发送</el-button>
                  </div>
                </div>
              </div>
            </el-card>
            <div class="show-more" v-show="showMoreQp" @click="loadMore">加载更多</div>
          </el-scrollbar>
        </div>
        <!-- 搜索结果列表 -->
        <div class="words-search-result" v-show="showPJResult">
          <i>搜索结果</i>
          <img
            src="../../assets/images/wd-back.png"
            @click="backPJList"
            class="backTree-btn"
            title="返回配件列表"
          >
          <el-scrollbar style="height:100%;margin-bottom: 30px;">
            <el-card
              class="box-card order-item-ctn"
              v-for="(item,index) in searchPJResult"
              :key="item.Id"
            >
              <div class="text item order-item" @click="choosePJ(item)">
                <img :src="QN_URL_BASE+item.PublicUrl" alt="" class="order-cover">
                <div>
                  <div class="order-name">{{item.Cn}}</div>
                  <div class="order-msg">编码：{{item.Code}} &nbsp;&nbsp;&nbsp;&nbsp;库存：10</div>
                </div>
              </div>
            </el-card>
            <div class="show-more" v-show="showMoreQpSearch" @click="loadMoreQpSearch">加载更多</div>
          </el-scrollbar>
        </div>
      </div>
    </div>
    <el-dialog :title="dialogtitle" :visible.sync="dialogVisible" width="800px">
      <div class="dialog-content">
        <!-- 快速创建询价单 -->
        <div v-show="dialogType==2">
          <el-table border="" :data="xjData.AutoPart" style="width: 100%">
            <el-table-column show-overflow-tooltip prop="Cn" label="汽配名称"></el-table-column>
            <el-table-column show-overflow-tooltip label="数量">
              <template slot-scope="scope">
                <el-input size="mini" type="number" min="1" v-model="scope.row.Count"/>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="单位">
              <template slot-scope="scope">
                <el-select
                  v-model.trim="scope.row.Unit"
                  placeholder="请选择"
                  style="width: 100%"
                  size="mini"
                >
                  <el-option v-for="item in Unit" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="备注">
              <template slot-scope="scope">
                <el-input size="mini" type="text" v-model.trim="scope.row.Remark" />
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!--修改常用语-->
        <div v-show="dialogType==1 || dialogType==0">
          <el-input v-model.trim="treeNodeName" placeholder="请输入常用语"></el-input>
        </div>
        <!--添加企业客户-->
        <div v-show="dialogType==3">
          <el-form :rules="rules" :model="clientformData" ref="clientform" label-width="100px">
            <el-form-item prop="Operator" hidden>
              <el-input type="hidden" v-model="clientformData.Operator"></el-input>
            </el-form-item>
            <el-form-item label="企业" prop="EntpId">
              <el-select v-model="clientformData.EntpId" filterable placeholder="请选择">
                <el-option
                  v-for="item in EntpList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="姓名" prop="Name">
              <el-input v-model.trim="clientformData.Name" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="Gender">
              <el-radio-group v-model="clientformData.Gender">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="手机号码" prop="PhoneNum">
              <el-input maxlength="11" v-model="clientformData.PhoneNum"></el-input>
            </el-form-item>
            <el-form-item label="QQ" prop="Qq">
              <el-input v-model.trim="clientformData.Qa" maxlength="15"></el-input>
            </el-form-item>
            <el-form-item label="微信" prop="Wechat">
              <el-input v-model.trim="clientformData.Wechat" maxlength="15"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="Email">
              <el-input v-model.trim="clientformData.Email" maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="Remark">
              <el-input v-model.trim="clientformData.Remark" maxlength="50"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="edit()">确 定</el-button>
      </span>
    </el-dialog>
    <!--添加汽配件组件-->
    <!-- <addAutoPartDialog
      ref="addAutoPartDialog"
      :visible.sync="AddApDialogVisible"
      v-bind:show="AddApDialogVisible"
      @controlApDialogVisible="controlApDialogVisible"
    ></addAutoPartDialog> -->
    <el-dialog title="添加汽配件" :visible.sync="AddApDialogVisible"  :fullscreen="true" @close="controlApDialogVisible(false)">
      <apDialogContent  ref="apDialogContent"  @controlApDialogVisible="controlApDialogVisible"></apDialogContent>
    </el-dialog>
  </div>
</template>
<script>
import apDialogContent from "@/components/workbench/addAutoPartDialog.vue";
export default {
  name: "dailyOperation",
  components: {
    apDialogContent
  },
  data() {
    let checkPhone = this.$util.checkPhone;
    let checkEmail = this.$util.checkEmail;
    return {
      // common
      Unit: ["件", "个", "片", "只", "台", "升", "毫升"],
      QN_URL_BASE: this.$util.QN_URL_BASE,
      tabInd: 0,
      filterText: "",
      // dailywords
      dailyWordsKey: "", // 常用语搜所关键字
      showSearchResult: false,
      wordSearchResult: null,
      choosedData: {
        data: null,
        node: null,
        ele: null
      },
      nowKhMsg: {}, // 当前用户信息
      treeNodeName: "", // 修改节点名称的值
      dialogType: 1,
      dialogVisible: false, // 显示dialog
      dialogtitle: "修改常用语",
      mytreeShow: true,
      commonTreeShow: true,
      myWords: [], // 我的常用语
      commonWords: [], // 公共常用语
      defaultProps: {
        children: "Children",
        label: "Sentence"
      },
      // access-log
      LastJoinTime: "", // 上次接入客服时间
      LastReception: "", // 接待人
      historyCjShow: true,
      historyXjShow: true,
      DealOrders: [], // 成交订单历史
      InquiryBills: [], // 询价单历史
      // daily-opts
      showMoreQpSearch: false, // 搜索汽配那里的的加载更多
      showPJResult: false, // 显示配件搜索结果
      showMoreQp: false,
      qpSearchText: "", // 搜索汽配名称
      qpList: [], // 汽配件列表
      searchPJResult: [],
      searchQPData: {
        // 获取汽配列表
        Code: "",
        Name: "",
        SId: "",
        key: "",
        page: 1,
        limit: 10
      },
      searchPJ: {
        // 搜索配件
        key: "",
        page: 1,
        limit: 10
      },
      qpChoosedList: [],
      xjData: {
        // 询价单数据
        SId: "", //客服ID
        SName: "", //
        UId: "", //正在聊天的客户ID
        AutoPart: []
      },
      EntpList: [],
      clientformData: {
        EntpId: "",
        Name: "",
        Gender: 1,
        PhoneNum: "",
        Qq: "",
        Wechat: "",
        Email: "",
        Remark: "",
        Operator: this.$util.getSessionStorage("userMsg")
          ? this.$util.getSessionStorage("userMsg").Id
          : ""
      },
      rules: {
        EntpId: [
          { required: true, message: "请选择企业", trigger: ["blur", "change"] }
        ],
        Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        PhoneNum: [{ required: true, validator: checkPhone, trigger: "blur" }],
        Email: [{ required: false, validator: checkEmail, trigger: "blur" }]
      },
      AddApDialogVisible: false //添加汽配件窗口是否展现
    };
  },
  computed: {
    getCurrChatClient() {
      return this.$store.getters.getCurrChatClient;
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree1.filter(val);
    },
    //监听当前聊天客户
    getCurrChatClient(value) {
      if (JSON.stringify(value) == "{}") {
        this.nowKhMsg = {};
        return;
      }
      if (this.nowKhMsg.uId == value.uId) {
        return;
      }
      this.nowKhMsg = value;
      this.getFkList();
    }
  },
  mounted() {},
  methods: {
    /**
     * 公共方法
     * */
    // 别动！！！老子恁死你
    init() {
      this.loadUsefulSentences();
      this.getQpList();
    },
    // 获取当前客户的信息,未使用
    getkhMsg(data) {
      this.nowKhMsg = data;
      this.getFkList();
    },
    // tab 切换
    tabToggle(i) {
      this.tabInd = i;
    },
    // 显示showDialog
    showDialog(type, data) {
      this.dialogType = type;
      if (type == 0) {
        this.dialogtitle = "新增常用语";
        this.treeNodeName = "";
      } else if (type == 1) {
        this.dialogtitle = "修改常用语";
        this.treeNodeName = data.Item.Sentence;
      } else if (type == 2) {
        if (!this.qpChoosedList[0]) {
          this.$message({
            message: "请先选择汽配件！",
            type: "warning"
          });
          return;
        }
        if (!this.nowKhMsg.uId) {
          this.$message({
            message: "请先接入客户！",
            type: "warning"
          });
          return;
        }
        this.dialogtitle = "快速创建询价单";
        this.xjData.AutoPart = [];
        let _qpChoosedList = this.qpChoosedList;
        for (let i = 0; i < _qpChoosedList.length; i++) {
          let _data = {
            PartId: _qpChoosedList[i].Id, //汽配件ID
            Count: 1, //数量
            Unit: "件", // 单位
            Remark: "", //备注
            Cn: _qpChoosedList[i].Cn
          };
          this.xjData.AutoPart.push(_data);
        }
      } else if (type == 3) {
        this.dialogtitle = "新增企业客户";
        this.dialogVisible = true;
        this.resetForm("clientform"); //重置表单
        let that = this;
        this.axios
          .get("/ClientManagement/GetEntpList", {
            params: {},
          })
          .then(resp => {
            let data = resp.data.data;
            if (resp.data.errcode == 0 && data) {
              that.EntpList = data;
            }
          });
      }

      if (data) {
        this.choosedData.data = data;
      } else {
        this.choosedData.data = "";
      }
      this.dialogVisible = true;
    },
    //重置表单
    resetForm(formName) {
      if (this.$refs[formName] != undefined) {
        this.$refs[formName].resetFields();
      }
    },

    /**
     * 常用语
     * */
    // 显示树，隐藏搜搜结果
    backTree() {
      this.showSearchResult = false;
      this.dailyWordsKey = "";
      this.wordSearchResult = [];
    },
    // 获取对应客服的常用语以及公共常用语
    loadUsefulSentences() {
      this.axios
        .get("/UsefulSentences/LoadUsefulSentences", {
          params: {
            SId: this.$store.state.userMsg.Id
          }
        })
        .then(response => {
          this.myWords = response.data.data.MySentences;
          //   if (response.data.data.MySentences.length == 0) {
          //     // this.append('','我的常用语') // todo
          //   }
          this.commonWords = response.data.data.CommSentences;
        });
    },
    // 搜索常用語
    dailyWordsSearch() {
      let searchval = this.dailyWordsKey.trim();
      if (!searchval || searchval == "") {
        this.$util.warningMsg("请输入搜索内容！");
        return;
      }
      this.axios.get("/UsefulSentences/SearchUsefulSentences", {
          params: {
            key: searchval
          }
        })
        .then(response => {
          //   this.wordSearchResult = JSON.parse(response.data.data).data;
          //   if (this.wordSearchResult.length > 0) {
          //     this.showSearchResult = true;
          //   }
          this.wordSearchResult = response.data.data;
          this.showSearchResult = true; //任何情况下都要展现搜索结果
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 渲染我的常用语
    renderContent(h, { node, data }) {
      return (
        <span class="custom-tree-node">
          <span
            on-click={() => this.chooseNode(data)}
            // class={node.level == 1 ? "daily-title" : "word-item"}
            title={data.Item.Sentence}
          >
            {data.Item.Sentence}
          </span>
          <span>
            <el-button
              type="text"
              size="mini"
              on-click={() => this.showDialog(0, data)}
            >
              新增{" "}
            </el-button>
            <el-button
              type="text"
              size="mini"
              on-click={() => this.showDialog(1, data)}
              //   v-show={node.level != 1}
            >
              编辑{" "}
            </el-button>
            <el-button
              type="text"
              size="mini"
              on-click={() => this.del(data)}
              v-show={data.Children.length == 0}
            >
              删除{" "}
            </el-button>
          </span>
        </span>
      );
    },
    // 渲染公共常用语
    renderCommon(h, { node, data }) {
      return (
        <span class="custom-tree-node common-word-node">
          <span
            on-click={() => this.chooseNode(data)}
            title={data.Item.Sentence}
          >
            {data.Item.Sentence}
          </span>
        </span>
      );
    },
    // 点击节点向父组件传值
    chooseNode(data) {
      if (!this.nowKhMsg.uId) {
        this.$message({
          message: "当前未接入客户",
          type: "warning"
        });
        return;
      }
      this.$emit("tansDailyWord", data.Item.Sentence);
    },
    // 刷新常用语
    reLoad() {
      this.loadUsefulSentences();
      this.$message({
        message: "刷新成功",
        type: "success"
      });
    },
    edit() {
      let data = this.choosedData.data;
      let that = this;
      // 新增常用语
      if (this.dialogType == 0) {
        if (!this.treeNodeName) {
          this.$util.warningMsg("请输入常用语");
          return;
        }
        this.axios
          .post("/UsefulSentences/EditUsefulSentences", {
            FId: data && data.Item ? data.Item.Id : "",
            SId: this.$store.state.userMsg.Id,
            Sentence: this.treeNodeName
          })
          .then(response => {
            this.loadUsefulSentences();
            this.$message({
              message: "新增成功",
              type: "success"
            });
            this.dialogVisible = false;
            this.treeNodeName = "";
          })
          .catch(error => {
            console.log(error);
            this.$message.error("新增失败！");
          });
      }
      // 编辑常用语
      else if (this.dialogType == 1) {
        if (!this.treeNodeName) {
          this.$util.warningMsg("请输入常用语");
          return;
        }
        this.axios
          .post("/UsefulSentences/EditUsefulSentences", {
            FId: data.Item.FId,
            Id: data.Item.Id,
            SId: this.$store.state.userMsg.Id,
            Sentence: this.treeNodeName
          })
          .then(response => {
            this.dialogVisible = false;
            this.treeNodeName = "";
            this.loadUsefulSentences();
            this.$message({
              message: "修改成功",
              type: "success"
            });
          })
          .catch(error => {
            console.log(error);
            this.$message.error("修改失败！");
          });
      }
      // 创建询价单
      else if (this.dialogType == 2) {
        this.axios
          .post("/Inquiry/AddInquiryBills", {
            UId: this.nowKhMsg.uId, // 客户id
            BillObjects: this.xjData.AutoPart
          })
          .then(response => {
            this.dialogVisible = false;
             this.getFkList();
            this.$message({
              message: "创建询价单成功",
              type: "success"
            });
          })
          .catch(error => {
            console.log(error);
            this.$message.error("创建询价单失败！");
          });
      }
      //创建企业客户
      else if (this.dialogType == 3) {
        this.$refs.clientform.validate(valid => {
          if (valid) {
            that.clientformData.data = false;
            this.axios
              .post("/ClientManagement/AddEntpClient", that.clientformData)
              .then(res => {
                var data = res.data.data;
                if (res.data.errcode == 0 && data) {
                  this.$confirm("该客户已存在, 是否查看客户详情?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                  })
                    .then(() => {
                      that.dialogVisible = false;
                      this.$emit("showClientDetail", { Uid: data, UType: 1 });
                    })
                    .catch(() => {});
                  return false;
                }
                this.$util.successMsg("新增成功");
                that.dialogVisible = false;
              })
              .catch(error => {
                this.$message.error("新增失败！");
              });
          }
        });
      }
    },
    // 删除常用语
    del(data) {
      let that = this;
      this.$util.elConfirm({
        that: this,
        content: "确定要删除这条常用语吗?",
        confirm() {
          that.axios
            .post("/UsefulSentences/DeleteUsefulSentences?ids=" + data.Item.Id)
            .then(response => {
              that.loadUsefulSentences();
              that.$message({
                message: "删除成功",
                type: "success"
              });
            })
            .catch(error => {
              console.log(error);
              that.$message.error("删除失败！");
            });
        }
      });
    },
    // 本页面公用节点隐藏
    hideEle(type) {
      if (type == 0) {
        this.mytreeShow = !this.mytreeShow;
      } else if (type == 1) {
        this.commonTreeShow = !this.commonTreeShow;
      } else if (type == 2) {
        this.historyCjShow = !this.historyCjShow;
      } else if (type == 3) {
        this.historyXjShow = !this.historyXjShow;
      }
    },
    // 树插件过滤
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    /**
     * 常用操作
     * */
    // 推送汽配件
    pushGoods(item){
      let _customerMsg = this.$store.state.customerMsg
      if (_customerMsg.uType == 1){
        let pushMsg = {
          customerMsg:this.$store.state.customerMsg,
          goodMsg:item
        }
        this.$store.commit('updatePushGoodMsg',pushMsg)
      }
      else {
        this.$util.warningMsg('只能发给企业用户')
      }
    },
    //返回汽配列表
    backPJList() {
      this.qpSearchText = "";
      this.showPJResult = false;
      this.searchPJ = {
        key: "",
        page: 1,
        limit: 10
      };
      this.searchPJResult = [];
    },
    // 跳转到常见问题处理文档
    gotoHelpDoc() {
      this.$router.push("/business/helpDoc/qa");
    },
    // 选择汽配件
    choosePJ(item) {
      let _qpChoosedList = this.qpChoosedList;
      for (let i = 0; i < _qpChoosedList.length; i++) {
        if (_qpChoosedList[i].Id == item.Id) {
          return;
        }
      }
      this.qpChoosedList.push(item);
    },
    // 删除选中的汽配件
    delqp(index) {
      this.qpChoosedList.splice(index, 1);
    },
    // 加载汽配列表
    getQpList() {
      this.axios.get("/AutoParts/LoadAutoParts", {
          params: this.searchQPData
        })
        .then(response => {
          let _data = response.data.data;
          for (let i = 0; i < _data.length; i++) {
            this.qpList.push(_data[i]);
          }
          if (_data.length == 10) {
            this.showMoreQp = true;
          } else {
            this.showMoreQp = false;
          }
        })
        .catch(error => {
          console.log(error);
          this.$message.error("汽配列表获取失败！");
        });
    },
    // 搜索汽配件
    searchQP(from) {
      let searchval = this.qpSearchText.trim();
      if (!searchval || searchval == "") {
        this.$util.warningMsg("请输入搜索内容！");
        return;
      }
      if (from != "more") {
        this.searchPJResult = [];
        this.showMoreQpSearch = false;
      }
      this.searchPJ.key = searchval;
      this.axios
        .get("/AutoParts/SearchAutoPart", {
          params: this.searchPJ
        })
        .then(response => {
          let result = JSON.parse(response.data.data);
          let data = result.data;
          if (data.length > 0) {
            for (let i = 0; i < data.length; i++) {
              this.searchPJResult.push(data[i]);
            }
            if (data.length >= 10) {
              this.showMoreQpSearch = true;
            } else {
              this.showMoreQpSearch = false;
            }
          } else {
            this.searchPJResult = [];
            this.$util.warningMsg("无搜索结果");
          }
          //显示搜索结果模块
          this.showPJResult = true;
        });
    },
    // 加载更多汽配列表
    loadMore() {
      this.searchQPData.page += 1;
      this.getQpList();
    },
    loadMoreQpSearch() {
      this.searchPJ.page += 1;
      this.searchQP("more");
    },
    /**
     * 访客记录
     * */
    // 获取访客记录列表
    getFkList() {
      this.axios
        .get("/ClientManagement/LoadVisitorsRecord", {
          params: {
            VId: this.nowKhMsg.uId // 访客uid
          }
        })
        .then(response => {
          let data = response.data.data;
          this.DealOrders = data.DealOrders;
          this.InquiryBills = data.InquiryBills;
          this.LastJoinTime = data.LastJoinTime; // 上次接入客服时间
          this.LastReception = data.LastReception; // 接待人
        })
        .catch(error => {
          console.log(error);
          this.$message.error("访客记录列表获取失败！");
        });
    },
    // 历史订单显示更多
    showMore(e) {
      e.srcElement.style.display = "none";
      e.srcElement.nextSibling.style.display = "block";
      e.srcElement.parentNode.previousSibling.style.height = "auto";
    },
    // 历史订单收起
    hideMore(e) {
      e.srcElement.style.display = "none";
      e.srcElement.previousSibling.style.display = "block";
      e.srcElement.parentNode.previousSibling.style.height = "76px";
    },
    //显示还是隐藏编辑汽配件框
    controlApDialogVisible(Visible) {
       try {
         this.$refs.apDialogContent.resetForm();
       } catch (error) {
         console.log(error)
       }
        this.AddApDialogVisible = Visible;
    }
  }
};
</script>
<style lang="less" scoped>
.words-search-result {
  padding-top: 50px;
  position: relative;
  .backTree-btn {
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
    width: 30px;
    height: 30px;
  }
  > i {
    margin: 0 auto;
    position: absolute;
    top: 16px;
    font-size: 16px;
  }
}
.dailyOperation {
  height: 100%;
  overflow: auto;
}

.daily-title {
  font-size: @font-sm;
  font-weight: bold;
  margin: 20px 0;
  cursor: pointer;
}
.my-daily-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.daily-words {
  position: relative;
  .opsons-ctn {
    position: absolute;
    width: 100%;
    bottom: 1px;
    left: 0;
  }
}

.tree-ctn {
  position: absolute;
  width: 100%;
  height: calc(100% - 72px);
  top: 72px;
  left: 0;
  right: 0;
  bottom: 30px;
  padding: 0 20px;
  overflow: auto;
}

.opsons-ctn {
  display: flex;
  background: @border4Color;
  > div {
    flex-grow: 1;
    text-align: center;
    line-height: 39px;
    cursor: pointer;
  }
}

.last-msg {
  margin-bottom: 20px;
  font-size: @font-sm;
}

.access-log-tree {
  bottom: 1px;
  height: calc(100% - 90px);
  top: 82px;
}

.order-item-ctn {
  margin-bottom: 20px;
  cursor: pointer;
}

.order-item {
  display: flex;
  justify-content: space-between;
  .order-cover {
    width: 70px;
    height: 50px;
    margin-right: 10px;
  }
  .goods-msg-125 {
    flex-grow: 1;
  }
  .order-name {
    font-size: @font-sm;
    margin-bottom: 10px;
  }
}

.daily-opts-btn-ctn {
  text-align: center;
  margin-bottom: 10px;
}

.daily-opts-tree {
  bottom: 1px;
  height: calc(100% - 160px);
  top: 159px;
}
.qp-choosed-ctn {
  max-width: 150px;
  display: flex;
  align-items: center;
  margin-top: 5px;
  margin-right: 5px;
}
.qp-choosed {
  display: inline-block;
  max-width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.history-item {
  padding-top: 10px;
  padding-bottom: 15px;
  border-bottom: 1px solid @border4Color;
}
.order-item-content {
  overflow: hidden;
}
.div-table-cell {
  line-height: 36px;
  text-align: center;
}
.history-order-num {
  display: flex;
  justify-content: center;
  align-items: center;
}
.quesheng {
  text-align: center;
  padding-top: 30px;
}
.show-more {
  text-align: center;
  color: @theme;
  cursor: pointer;
  padding-bottom: 20px;
}
.qp-choosed-label-ctn {
  height: 60px;
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
}
</style>
<style lang="less">
.dailyOperation {
  .common-word-node {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .el-tree-node__content {
    border-bottom: 1px solid @border4Color;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .daily-title {
    font-size: @font-sm;
    font-weight: bold;
    margin: 20px 0;
    cursor: pointer;
  }
  .word-item {
    max-width: 200px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
</style>
